

const getDaysFromDate = (currentDateString) => {
    let start = new Date('Thurs Jan 1 1970 00:00:00 GMT')
    let currentTime = new Date(`${currentDateString}`)
    let difference = currentTime.getTime() - start.getTime()
    return Math.floor(difference / 1000 / 60 / 60 / 24) + 1
}

export default getDaysFromDate